<template>
  <div class="line">
    <form style="display: flex; align-items: center;" @submit.prevent="edit()">
      <template v-if="flag">
        <app-text-input
          :label="$ml.get(`EXTRACTION METHOD`)"
          v-model="data.name"
          type="text"
        />

        <app-sel
          class="drop"
          styling="inline"
          v-model="data.unit"
          key-name="label"
          :items="
            Object.keys(
              $store.getters['nutrients/getNutrientByKey'](data.type).units
            ).map((item) => {
              return { label: item };
            })
          "
        >
          <template v-slot="{ items }">
            <app-sel-opt :value="unit" :key="i * 2" v-for="(unit, i) in items">
              {{ $ml.get(unit.label) }}
            </app-sel-opt>
          </template>
        </app-sel>

        <app-text-input
          :label="$ml.get(`Low`)"
          :value="convertLow()"
          @input="onInputL"
          :type="type"
          :min="minL"
        />
        <app-text-input
          :label="$ml.get(`Adequate`)"
          :value="convertAd()"
          @input="onInputA"
          :type="type"
          :min="data.lowNum"
        />
        <app-text-input
          :label="$ml.get(`High`)"
          :value="convertHigh()"
          @input="onInputH"
          :type="type"
          :min="data.adequateNum"
        />
      </template>
      <template v-else>
        <div class="row">Name: {{ data.name }}</div>
        <div class="row">Unit: {{ data.unit ? data.unit : "ppm" }}</div>
        <div class="row">Low: {{ toUnitC(data.lowNum) }}</div>
        <div class="row">Adequate: {{ toUnitC(data.adequateNum) }}</div>
        <div class="row">High: {{ toUnitC(data.highNum) }}</div>
      </template>
      <app-btn type="submit" :disabled="!isDisabled">
        <template>
          {{ $ml.get(`save`) }}
        </template>
      </app-btn>
      <app-btn @click="remove()" styling="outline">
        {{ $ml.get(`delete`) }}
      </app-btn>
    </form>
  </div>
</template>

<script>
import { UnitConverter } from "@/mixins/unit-converter.mixin";

export default {
  props: {
    data: Object,
    nut: String,
    type: { default: "number" },
  },
  data() {
    return {
      flag: true,
      minL: 0,
    };
  },
  mixins: [UnitConverter],
  computed: {
    isDisabled() {
      return this.data.name &&
        this.data.highNum > this.data.adequateNum &&
        this.data.adequateNum > this.data.lowNum
        ? true
        : false;
    },
  },
  methods: {
    toUnitC(val) {
      return val
        ? this.toUnit(this.data.type, this.data.unit, val).toFixedGentle(2)
        : 0;
    },
    onInputL(value) {
      // converting view
      if (this.isSeveralTyped) {
        value = this.unconvertNutrientType(
          this.data.type,
          this.data.unit,
          value
        );
      }

      this.data.lowNum = this.toPpm(this.data.type, this.data.unit, value);
      if (this.data.n_form) {
        this.$store.commit("tests/soil/computeN");
      }
    },
    onInputH(value) {
      // converting view
      if (this.isSeveralTyped) {
        value = this.unconvertNutrientType(
          this.data.type,
          this.data.unit,
          value
        );
      }
      this.data.highNum = this.toPpm(this.data.type, this.data.unit, value);
      if (this.data.n_form) {
        this.$store.commit("tests/soil/computeN");
      }
    },
    onInputA(value) {
      // converting view
      if (this.isSeveralTyped) {
        value = this.unconvertNutrientType(
          this.data.type,
          this.data.unit,
          value
        );
      }

      this.data.adequateNum = this.toPpm(this.data.type, this.data.unit, value);
      if (this.data.n_form) {
        this.$store.commit("tests/soil/computeN");
      }
    },
    convertLow() {
      let val = this.data.lowNum;

      if (this.isSeveralTyped) {
        val = this.convertNutrientType(this.data.type, this.data.unit, val);
      }

      val = this.toUnit(this.data.type, this.data.unit, val);
      return val ? val : null;
    },
    convertHigh() {
      let val = this.data.highNum;

      if (this.isSeveralTyped) {
        val = this.convertNutrientType(this.data.type, this.data.unit, val);
      }

      val = this.toUnit(this.data.type, this.data.unit, val);
      return val ? val : null;
    },
    convertAd() {
      let val = this.data.adequateNum;

      if (this.isSeveralTyped) {
        val = this.convertNutrientType(this.data.type, this.data.unit, val);
      }

      val = this.toUnit(this.data.type, this.data.unit, val);
      return val ? val : null;
    },
    edit() {
      if (!this.flag) {
        this.flag = true;
        return;
      }
      this.$store
        .dispatch("labs/popup/editNut", { nut: this.nut, id: this.data.id })
        .then((res) => {
          this.$notify({
            group: "notices",
            title: this.$ml.get(`Ext successfully edited!`),
            type: "Success",
          });
          this.$emit("emit");
          this.flag = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notices",
            title: err,
            type: "error",
          });
        });
    },
    remove() {
      this.$store
        .dispatch("labs/popup/deleteExt", { nut: this.nut, id: this.data.id })
        .then((res) => {
          this.$notify({
            group: "notices",
            title: this.$ml.get(`Ext successfully deleted!`),
            type: "Success",
          });
          this.$emit("emit");
        })
        .catch((err) => {
          this.$notify({
            group: "notices",
            title: err,
            type: "error",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.drop {
  .dropdown {
    background: white !important;
  }
}
.line {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1px solid #e0e0e0;
  margin: 20px 0;
  padding: 10px 0;
  .text-input,
  .row,
  .drop {
    width: calc(20% - 20px);
    margin: 0 10px;
  }
  .btn {
    width: calc(10% - 10px);
    margin: 15px 5px;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    > .text-input,
    .btn,
    .row,
    .drop {
      width: 100%;
      margin: 15px 0;
      margin-top: 25px;
    }
  }
}
</style>
